import React, { Text } from 'react-native';
import moment from 'moment';
import { translate } from '../../services/translate';
import Toast from 'react-native-toast-message';
import { deacService } from '../../services/central-api/deac';
import html2pdf from 'html2pdf.js';
import ejs from 'ejs';
import deacSchedule from '../../../assets/deac_schedule.ejs';
import ExcelJS from 'exceljs';
import { Dispatch, SetStateAction } from 'react';

export function formatRelativeTime(applicationStart: Date): string {
    const momentData = moment(applicationStart);
    const now = moment();

    const diffMinutes = now.diff(momentData, 'minutes');
    const diffHours = now.diff(momentData, 'hours');
    const diffDays = now.diff(momentData, 'days');

    if (diffMinutes < 1) {
        return translate('now');
    } else if (diffMinutes < 60) {
        return translate('xMinutesAgo', { minutes: diffMinutes });
    } else if (diffHours < 24) {
        return translate('xHoursAgo', { hours: diffHours });
    } else if (diffDays === 1) {
        return translate('yesterday');
    } else {
        return momentData.format('DD/MM');
    }
}

export async function getDeacSchedule(
    mode: 'pdf' | 'csv' | 'xlsx',
    setIsGeneratingSchedule: Dispatch<SetStateAction<boolean>>,
    filters: VacanciesScheduleParameters,
    ids?: number[],
) {
    try {
        setIsGeneratingSchedule(true);
        let info;
        if (ids != undefined) {
            info = await deacService.getSchedule({ vacanciesIds: ids });
        } else {
            info = await deacService.getSchedule(filters);
        }

        const filename = ids != undefined && ids.length === 1 && info.schedules[0] ? translate('schedule').toLowerCase() + `_${info.schedules[0].vacancy.id}_${info.schedules[0].workplaceName}` : translate('schedule').toLowerCase();
        if (mode === 'pdf') {
            const template = await (await fetch(deacSchedule)).text();
            await html2pdf(ejs.render(template, info), { filename: filename + `.pdf` });
        } else {
            const workbook = new ExcelJS.Workbook();
            const sheet = workbook.addWorksheet('Escala');
            sheet.addRow(['Escala de trabalho', `Gerada em ${info.generatedDate}`]).commit();
            sheet.addRow([]).commit();

            for (const schedule of info.schedules) {
                sheet.addRow([schedule.mainScheduleHeader, schedule.workplaceName]).commit();
                sheet.addRow([schedule.vacancy.id, schedule.vacancy.title, schedule.start, schedule.end]).commit();
                sheet.addRow(['#', translate('agent'), translate('unit'), 'Horário entrada', 'Visto', 'Horário saída', 'Visto']).commit();

                let index = 1;
                for (const agent of schedule.agents) {
                    sheet.addRow([index, agent.agent, agent.agentUnit]).commit();
                    index += 1;
                }

                sheet.addRow([]).commit();
                sheet.addRow([]).commit();
            }

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const objectUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = objectUrl;
            link.download = filename + '.xlsx';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(objectUrl);
        }
    } catch (err) {
        console.error(err);
        Toast.show({
            type: 'sentinelxError',
            text1: translate('unexpectedError'),
        });
    } finally {
        setIsGeneratingSchedule(false);
    }
}

export function parseTextWithBold(text: string, color?: string): (string | JSX.Element)[] {
    const parts = text.split(/(\*\*.*?\*\*)/g);
    return parts.map((part, index) => {
        if (part.startsWith('**') && part.endsWith('**')) {
            return (
                <Text key={index} style={[{ fontWeight: '700' }, color ? { color: color } : {}]}>
                    {part.slice(2, -2)}
                </Text>
            );
        }
        return part;
    });
}
